module.exports = __webpack_public_path__ + "static/media/back-black.8ad42413.png";